<template>
  <el-container
    class="is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div
          style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;"
        >
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item>網頁設計</el-breadcrumb-item>
            <el-breadcrumb-item>首頁</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/newHomeBanner' }">Banner</el-breadcrumb-item>
            <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main v-loading="isLoading" :element-loading-text="loadingHint">
        <!-- <editor-form :form="form" style="margin-top: 80px;" /> -->
        <el-form label-width="160px" style="max-width: 520px;" @submit.native.prevent>

        <el-tabs value="common" type="card">
          <el-tab-pane label="通用" name="common">
            <el-form-item label="排序">
              <el-input v-model="form.Tw.Sort" type="number"></el-input>
            </el-form-item>
            <el-form-item label="置頂" style="text-align: left;">
              <el-switch
                v-model="form.Tw.IsTop"
                active-text="是"
                inactive-text="否"
                inactive-color="red"
              ></el-switch>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>

        <el-tabs v-model="activeLang" type="card">
          <el-tab-pane label="繁中" name="Tw">
            <editor-form :form="form" form-key="Tw"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Cn')" label="簡中" name="cn">
            <editor-form :form="form" form-key="Cn"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('En')" label="英文" name="en">
            <editor-form :form="form" form-key="En"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Jp')" label="日文" name="jp">
            <editor-form :form="form" form-key="Jp"/>
          </el-tab-pane>
        </el-tabs>
        </el-form>

        <p class="auto-save-hint">{{autoSaveHint}}</p>

        <el-switch
          v-model="form.IsActive"
          class="switch-deploy"
          active-text="上架"
          inactive-text="下架"
          inactive-color="red"
        ></el-switch>

        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">其他語言版本的圖片，也使用中文版本的圖片</div>
          <el-button type="primary" class="btn-translate" size="mini" @click="autoTranslate">複製中文圖片</el-button>
        </el-tooltip>

        <el-button type="primary" class="btn-upload" size="mini" @click="submit">
          送出
          <i class="el-icon-upload el-icon--right"></i>
        </el-button>
      </el-main>

    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import EditorForm from '@/data/newHomeBanner/view/editor-form.vue'
import MixinOfPreventLeaveEditPage from '@/utils/mixin-prevent-leave.vue'
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinOfTranslation from '@/utils/mixin-translate.vue'
import MixinAutoSave from '@/utils/mixin-autosave.vue' // cacheKey required

export default {
  mixins: [MixinOfPreventLeaveEditPage, MixinLanguages, MixinOfTranslation, MixinAutoSave],
  components: {
    LeftMenu,
    TopHeader,
    EditorForm
  },
  data () {
    return {
      oriObj: {},
      form: {
        IsActive: true,
        Tw: { IsActive: true },
        Cn: { IsActive: true },
        En: { IsActive: true },
        Jp: { IsActive: true }
      },
      activeLang: 'Tw',
      isLoading: false,
      loadingHint: ''
    }
  },
  computed: {
    isEdit () {
      return this.$route.name !== 'createNewHomeBanner'
    },
    title () {
      return this.isEdit ? this.form.Tw.Title : '新增'
    }
  },
  methods: {
    submit () {
      if (!this.validateInput()) {
        return
      }
      if (this.isImageUploading()) {
        return alert('圖片上傳中，請稍後再送出')
      }
      // 通用欄位
      for (let lang of this.languages) {
        this.form[lang].IsActive = this.form.Tw.IsActive
        this.form[lang].Sort = this.form.Tw.Sort
        this.form[lang].IsTop = this.form.Tw.IsTop
      }

      for (let lang of this.languages) {
        this.form[lang].Sort = parseInt(this.form[lang].Sort) || 0
      }

      this.isLoading = true

      this.loadingHint = '正在上傳資料'

      let promise = this.isEdit
        ? this.$services.newHomeBanner.edit(this, this.form)
        : this.$services.newHomeBanner.add(this, this.form)
      promise
        .then(res => {
          let ok = res && res.data && res.data.status === 'ok'
          if (ok) this.onObjAddedit(res)
        })
        .catch(this.$handleServiceError)
        .finally(() => {
          this.isLoading = false
        })
    },
    isImageUploading () {
      for (let lang of this.languages) {
        // 封面圖片
        if (this.form[lang]['coverImageBlob@3x'] && this.form[lang]['coverImageBlob@3x'] instanceof Blob) return true
        if (this.form[lang]['coverImageBlob@2x'] && this.form[lang]['coverImageBlob@2x'] instanceof Blob) return true
        if (this.form[lang]['coverImageBlob@1x'] && this.form[lang]['coverImageBlob@1x'] instanceof Blob) return true
      }
      return false
    },
    onObjAddedit (res) {
      this.clearCache()
      this.isSubmitted = true
      this.loadResult(res)
      this.$message({
        message: `${this.isEdit ? '修改' : '新增'}成功`,
        type: 'success'
      })
      this.form = {}
      this.$router.push({ name: 'newHomeBanner-list' })
    },
    loadResult (res) {
      var newObj = res.data.result
      if (!this.isEdit) {
        this.$store.state.newHomeBanner.list.splice(0, 0, newObj)
      } else {
        newObj = Object.assign(this.oriObj, newObj)
        let idx = this.$store.state.newHomeBanner.list.findIndex(
          o => o.ID === newObj.ID
        )
        if (idx >= 0) {
          this.$set(this.$store.state.newHomeBanner.list, idx, newObj)
          this.oriObj = newObj
        } else {
          console.error(`unknown newHomeBanner for id ${newObj.ID}`)
        }
      }
    },
    validateInput () {
      var errMsg = null

      for (let lang of this.languages) {
        if (!this.form[lang].ImageURLX3) {
          errMsg = '請上傳電腦版圖片' + lang
          break
        }
        if (!this.form[lang].ImageURLX2) {
          errMsg = '請上傳手機版圖片' + lang
          break
        }
      }
      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
        return false
      }

      if (errMsg) {
        this.$alert(errMsg, '錯誤', {
          confirmButtonText: '確認',
          type: 'error'
        })
      }
      return errMsg === null
    },
    // tranlsate
    autoTranslate () {
      // this.isLoading = true

      // const translateKeys = ['Title', 'Description']
      const syncKeys = ['ImageURLX3', 'ImageURLX2', 'ImageURLX1', 'VideoID', 'VideoURL']

      this.syncForm(syncKeys)
      // let promises1 = this.translateForm(translateKeys)

      // Promise.all([promises1]).then(() => {
      //   this.isLoading = false
      // })
    }
  },
  created () {
    let id = parseInt(this.$route.params.id)
    if (id && id > 0) {
      let idx = this.$store.state.newHomeBanner.list.findIndex(o => o.ID === id)
      if (idx >= 0) {
        this.oriObj = this.$store.state.newHomeBanner.list[idx]
        this.form = JSON.parse(JSON.stringify(this.oriObj))
      } else {
        console.error(`unknown newHomeBanner for id ${id}`)
      }
    }

    // cache
    this.cacheKey = 'cache-newHomeBanner-' + (this.isEdit ? this.oriObj.ID : 0)
    let cache = this.getCache()
    if (cache) {
      this.confirmLoadCache().then(result => {
        if (result !== 'loaded') return
        let cacheForm = JSON.parse(cache)
        this.form = cacheForm
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>

<style>
.el-tabs {
  height: 100%;
}
.el-tabs .el-tabs__content {
  height: calc(100% - 50px);
  overflow-y: auto;
}
.el-tab-pane {
  max-width: 1030px;
}
</style>
<style scoped>

.btn-translate {
  position: absolute;
  top: 26px;
  right: 110px;
}

.switch-deploy {
  position: absolute !important;
  top: 30px;
  right: 230px;
}

.auto-save-hint {
  position: absolute;
  top: 33px;
  right: 424px;
  color: gray;
  font-size: 14px;
}
</style>
